<template>
  <div class="tags" v-if="showTags">
    <ul>
      <li
        class="tags-li"
        v-for="(item, index) in tagsList"
        :class="{ active: isActive(item.path) }"
        :key="index"
      >
        <!-- <router-link :to="item.path" class="tags-li-title">{{
          `/${item.title}`
        }}</router-link> -->
        <span class="tags-li-title"> {{ `/${item.title}` }}</span>
        <!-- <span class="tags-li-icon" @click="closeTags(index)">
          <i class="el-icon-close"></i>
        </span> -->
      </li>
    </ul>
    <!-- <div class="tags-close-box">
      <el-dropdown @command="handleTags">
        <el-button size="mini" type="primary">
          标签选项
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <template #dropdown>
          <el-dropdown-menu size="small">
            <el-dropdown-item command="other">关闭其他</el-dropdown-item>
            <el-dropdown-item command="all">关闭所有</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div> -->
  </div>
</template>

<script>
export default {
  computed: {
    tagsList() {
      return this.$store.state.tagsList;
    },
    showTags() {
      return this.tagsList.length > 0;
    },
  },
  methods: {
    isActive(path) {
      return path === this.$route.fullPath;
    },
    // 关闭单个标签
    closeTags(index) {
      const delItem = this.tagsList[index];
      this.$store.commit("delTagsItem", { index });
      const item = this.tagsList[index]
        ? this.tagsList[index]
        : this.tagsList[index - 1];
      if (item) {
        delItem.path === this.$route.fullPath && this.$router.push(item.path);
      } else {
        this.$router.push("/indexpage");
      }
    },
    // 关闭全部标签
    // closeAll() {
    //   this.$store.commit("clearTags");
    //   this.$router.push("/indexpage");
    // },
    // 关闭其他标签
    // closeOther() {
    //   const curItem = this.tagsList.filter((item) => {
    //     return item.path === this.$route.fullPath;
    //   });
    //   this.$store.commit("closeTagsOther", curItem);
    // },
    // 设置标签
    setTags(route) {
      const isExist = this.tagsList.some((item) => {
        return item.path === route.fullPath;
      });
      // isExist:true / false
      if (!isExist) {
        // if (this.tagsList.length >= 8) {
        //   this.$store.commit("delTagsItem", { index: 0 });
        // }
        // 只设置第一级和第二级标签，并且要是第一级标签的话tagsList要清空
        // console.log(this.tagsList, "this.tagsList");

        this.$store.commit("clearTags");
        if (
          route.name == "user_list" ||
          route.name == "avatarnicknameapproval" ||
          route.name == "feedback"
        ) {
          this.$store.commit("setTagsItem", {
            name: route.name,
            title: `用户管理/${route.meta.title}`,
            path: route.fullPath,
          });
        } else if (
          route.name == "dynamicwaterion_list" ||
          route.name == "equipment_list"
        ) {
          this.$store.commit("setTagsItem", {
            name: route.name,
            title: `消毒机设备管理/${route.meta.title}`,
            path: route.fullPath,
          });
        } else if (
          route.name == "userpoint_list" ||
          route.name == "exchange_list"
        ) {
          this.$store.commit("setTagsItem", {
            name: route.name,
            title: `打卡积分管理/${route.meta.title}`,
            path: route.fullPath,
          });
        } else if (
          route.name == "app_basesetting" ||
          route.name == "app_edition" ||
          route.name == "app_regagreement" ||
          route.name == "app_manual" ||
          route.name == "app_abuotus" || 
          route.name == "app_android" || 
          route.name == "app_ios" 
        ) {
          this.$store.commit("setTagsItem", {
            name: route.name,
            title: `APP管理/${route.meta.title}`,
            path: route.fullPath,
          });
        } else if (route.name == "systemlog" || route.name == "systemuser") {
          this.$store.commit("setTagsItem", {
            name: route.name,
            title: `系统管理/${route.meta.title}`,
            path: route.fullPath,
          });
        } else if(
          route.name == "cooperation" || 
          route.name == "addtoken" 
        ){
          this.$store.commit("setTagsItem", {
            name: route.name,
            title: `一些相关内容/${route.meta.title}`,
            path: route.fullPath,
          });
        }else{
          this.$store.commit("setTagsItem", {
            name: route.name,
            title: route.meta.title,
            path: route.fullPath,
          });
        }
      }
    },
    handleTags(command) {
      command === "other" ? this.closeOther() : this.closeAll();
    },
  },
  watch: {
    $route(newValue) {
      this.setTags(newValue);
    },
  },
  created() {
    this.setTags(this.$route);
    // 关闭当前页面的标签页
    // this.$store.commit("closeCurrentTag", {
    //     $router: this.$router,
    //     $route: this.$route
    // });
  },
};
</script>


<style>
.tags {
  position: relative;
  height: 40px;
  overflow: hidden;
  background: #f9f9f9;
  padding-right: 120px;
  /* box-shadow: 0 5px 10px #ddd; */
}

.tags ul {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}
.tags-li:nth-of-type(1) {
  padding-left: 20px;
}
.tags-li {
  float: left;
  /* margin: 3px 0 2px 0; */
  border-radius: 3px;
  font-size: 12px;
  overflow: hidden;
  /* cursor: pointer; */
  height: 40px;
  line-height: 40px;
  /* border: 1px solid #e9eaec; */
  background: #fff;
  /* padding: 0 5px 0 12px; */
  vertical-align: middle;
  color: #666;
  -webkit-transition: all 0.3s ease-in;
  -moz-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in;
}

.tags-li:not(.active):hover {
  background: #f8f8f8;
}
.tags-li.active {
  border: none !important;
  background-color: #f9f9f9 !important;
}

.tags-li-title {
  font-size: 14px !important;
  font-family: PingFangSC-Medium, PingFang SC !important;
  font-weight: 600 !important;
  color: #009e90 !important;
}

.tags-li-title {
  float: left;
  /* max-width: 80px; */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  /* margin-right: 5px; */
  color: #666;
}

.tags-li.active .tags-li-title {
  color: #fff;
}

/* .tags-close-box {
  position: absolute;
  right: 0;
  top: 0;
  box-sizing: border-box;
  padding-top: 1px;
  text-align: center;
  width: 110px;
  height: 30px;
  background: #fff;
  box-shadow: -3px 0 15px 3px rgba(0, 0, 0, 0.1);
  z-index: 10;
} */
</style>
